import React, { useContext, useRef, useState, useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Checkbox } from 'primereact/checkbox';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Skeleton } from 'primereact/skeleton';
import { BrCalendar } from './BrCalendar';
import { ScrollPanel } from 'primereact/scrollpanel';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ErrorValidationMessage } from './ErrorValidationMessage';
import { TabelaMatriculasPerfil } from './TabelaMatriculasPerfil';
import api from '../api/api';
import '../layout/sass/_form.scss';
import { AuthContext } from '../contexts/AuthContext';
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css';
import { OPCOES_DEFICIENCIA } from '../utils/constantes';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';

export const FormPerfis = ({ isEditing, isLoading, defaultValues }) => {

    const history = useHistory();
    const toast = useRef(null);
    const fileUploadRef = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [showLGPD, setShowLGPD] = useState(false);
    const [showDocs, setShowDocs] = useState(false);
    const [arquivosAluno, setArquivosAluno] = useState([]);
    const [showObs, setShowObs] = useState(false);

    const [uploadMessage, setUploadMessage] = useState('');
    const [loadingDocs, setLoadingDocs] = useState(false);

    const { signUp } = useContext(AuthContext);

    const schema = Yup.object().shape({
        nome: Yup.string().required("O nome é obrigatório").max(200, "O nome dete ter no máximo 200 caracteres"),
        cpf: Yup.string().required("O CPF é obrigatório").matches(/^\d{11}$/, "O CPF deve ter exatamente 11 números"),
        email: Yup.string().max(198, "O e-mail deve ter no máximo 198 caracteres").required("O e-mail é obrigatório").email("O e-mail inserido é inválido"),
        dataNascimento: Yup.date().max(new Date(), "Data de nascimento inválida").typeError("Uma data deve ser inserida").required("A data de nascimento é obrigatória"),
        celular: Yup.string().required("O celular é obrigatório"),
        lgpdAceite: Yup.boolean().required("É obrigatório aceitar os termos para prosseguir").oneOf([true], "É obrigatório aceitar os termos para prosseguir"),
        instrutor: Yup.boolean(),
    });

    const formik = useFormik({
        initialValues: defaultValues,
        validationSchema: schema,
        enableReinitialize: true,
        onSubmit: async (data) => {
            setIsSubmiting(true);
            try {
                if (!isEditing) {
                    await api.post("perfil", data);
                    if (data.tipo === 'ADMIN' || data.tipo === 'INSTRUTOR') {
                        await signUp(data.email, 'conservatorio123', data.nome);
                    }
                    formik.resetForm();
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `${data.nome} adicionado(a) com sucesso` });
                    setTimeout(() => history.push('/perfis'), 2000);
                } else {
                    await api.put("perfil", data);
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `${data.nome} atualizado(a) com sucesso` });
                    setTimeout(() => history.push('/perfis'), 2000);
                }
            } catch (error) {
                toast.current.show({ life: 2000, severity: 'error', summary: !isEditing ? 'Erro ao cadastrar perfil!' : 'Erro ao editar perfil!', detail: error.response?.data });
            }
            setIsSubmiting(false);
        }
    });

    const verificaCPF = async (cpf) => {
        if (!isEditing) {
            const RespCpf = await api.get(`perfil/cpf/${cpf}`);
            if (RespCpf.status === 200 && RespCpf.data) {
                toast.current.show({ life: 5000, severity: 'error', summary: 'Perfil existente para o CPF', detail: `Perfil de ${RespCpf.data.nome}` });
            }
        }
    };

    const verificaEmail = async (email) => {
        if (!isEditing && email) {
            try {
                const response = await api.get(`perfil/email/${email}`);
                if (response.status === 200 && response.data) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'E-mail já cadastrado', detail: `Este e-mail pertence a ${response.data.nome}` });
                }
            } catch (error) {
                if (error.response?.status !== 404) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'E-mail duplicado no sistema', detail: `Favor verificar os perfis para este email: ${email}` });
                }
            }
        }
    };

    const getDocs = async () => {
        const cpf = formik.values.cpf;
        try {
            const response = await api.get(`/matricula/arquivos/${cpf}`);
            if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
                setArquivosAluno(response.data);
            } else {
                setArquivosAluno([]);
            }
        } catch (error) {
            setArquivosAluno([]);
        }
    };

    useEffect(() => {
        const cpf = formik.values.cpf;
        const apenasNumeros = cpf ? cpf.replace(/\D/g, '') : '';
        if (apenasNumeros.length === 11) {
            getDocs();
            verificaCPF(apenasNumeros);
        } else {
            setArquivosAluno([]);
        }
    }, [formik.values.cpf]);

    const baixarArquivo = async (arquivo) => {
        try {
            const response = await api.get(`/matricula/download/${arquivo}`, { responseType: "blob" });
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", arquivo);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            alert("Não foi possível baixar o arquivo.");
        }
    };

    const uploadHandler = async (e) => {
        const file = e.files[0];
        const cpf = formik.values.cpf;
        const nomeAluno = formik.values.nome || 'Desconhecido';
        if (!file) return;
        setLoadingDocs(true);
        try {
            const formData = new FormData();
            formData.append('doc', file);
            formData.append('cpf', cpf);
            formData.append('nomeAluno', nomeAluno);

            await api.post('/matricula/uploadDoc', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            setUploadMessage('Sucesso!');
            getDocs();
            if (fileUploadRef.current) fileUploadRef.current.clear();
        } catch (error) {
            setUploadMessage('Erro no envio.');
        } finally {
            setLoadingDocs(false);
            setTimeout(() => setUploadMessage(''), 3000);
        }
    };

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const monName = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
    const now = new Date();
    let day = now.getDate();
    let month = now.getMonth();
    let year = now.getFullYear();

    return (
        <>
            <Toast ref={toast} position="bottom-right" />
            
            {/* DIALOG LGPD */}
            <Dialog visible={showLGPD} onHide={() => setShowLGPD(false)} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '50vw' }}>
                <div className="termo-container">
                    <ScrollPanel className="termo-content" style={{ height: '400px' }}>
                        <h1>TERMO DE CONSENTIMENTO PARA TRATAMENTO DE DADOS PESSOAIS (LGPD)</h1>
                        <p>Ao utilizar os serviços, você declara o seu <b>EXPRESSO CONSENTIMENTO</b> para coleta, tratamento e armazenamento de dados para fins de cadastramento escolar e alocação de vagas.</p>
                        <p>Os dados coletados incluem Nome, CPF, Data de Nascimento, Endereço, E-mail, Telefone, Voz e Imagem para fins educativos, artísticos e de divulgação institucional.</p>
                        <br /><span>Patos de Minas, {day} de {monName[month]} de {year}.</span>
                    </ScrollPanel>
                </div>
            </Dialog>

            {/* DIALOG OBSERVAÇÕES */}
            <Dialog header="Observações do Perfil" visible={showObs} onHide={() => setShowObs(false)} className="p-fluid" style={{ width: '60vw', maxWidth: '1650px' }}>
                <div style={{ marginBottom: '2rem' }}>
                    <ReactQuill theme="snow" value={formik.values.obs} onChange={(content) => formik.setFieldValue('obs', content)} style={{ height: '320px' }} />
                    {formik.errors.obs && formik.touched.obs && <ErrorValidationMessage message={formik.errors.obs} />}
                </div>
            </Dialog>

            {/* DIALOG DOCUMENTOS (AGORA SEMPRE VISÍVEL COM OPÇÃO DE UPLOAD) */}
            <Dialog header="Documentação do Prontuário" visible={showDocs} onHide={() => setShowDocs(false)} className="p-fluid" style={{ width: '50vw', maxWidth: '900px' }}>
                <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>Anexar Novo Documento</label>
                    <FileUpload ref={fileUploadRef} mode="advanced" customUpload uploadHandler={uploadHandler} chooseLabel="Escolher Arquivo" uploadLabel="Enviar" cancelLabel="Cancelar" maxFileSize={10000000} disabled={loadingDocs || !formik.values.cpf} />
                    {loadingDocs && <ProgressSpinner style={{ width: '30px', height: '30px', marginTop: '10px' }} />}
                    {uploadMessage && <p style={{ color: uploadMessage === 'Sucesso!' ? 'green' : 'red', fontWeight: 'bold', marginTop: '10px' }}>{uploadMessage}</p>}
                    
                    <h5 style={{ marginTop: '2rem', borderBottom: '1px solid #ccc', paddingBottom: '5px' }}>Documentos Anexados</h5>
                    {arquivosAluno.length > 0 ? (
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            {arquivosAluno.map((arquivo, index) => (
                                <li key={index} style={{ marginBottom: '5px' }}>
                                    <Button label={arquivo} icon="pi pi-download" className="p-button-text p-button-sm" onClick={() => baixarArquivo(arquivo)} />
                                </li>
                            ))}
                        </ul>
                    ) : <p style={{ fontStyle: 'italic', color: '#777', marginTop: '10px' }}>Nenhum documento encontrado para este perfil.</p>}
                </div>
            </Dialog>

            {/* FORMULÁRIO PRINCIPAL */}
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <div className="p-col-12">
                    <h2 className="p-mt-0">Perfis..</h2>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">
                            
                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="nome" className={classNames({ 'p-error': isFormFieldValid('nome') })}>Nome</label>
                                {!isLoading ? <InputText id="nome" name="nome" className={classNames({ 'p-invalid': isFormFieldValid('nome') })} value={formik.values.nome} onChange={formik.handleChange} /> : <Skeleton height="35px" />}
                                {formik.errors.nome && formik.touched.nome && <ErrorValidationMessage message={formik.errors.nome} />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="cpf" className={classNames({ 'p-error': isFormFieldValid('cpf') })}>CPF</label>
                                {!isLoading ? <InputMask id="cpf" name="cpf" mask="999.999.999-99" unmask={true} value={formik.values.cpf} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('cpf') })} /> : <Skeleton height="35px" />}
                                {formik.errors.cpf && formik.touched.cpf && <ErrorValidationMessage message={formik.errors.cpf} />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="email" className={classNames({ 'p-error': isFormFieldValid('email') })}>E-mail</label>
                                {!isLoading ? <InputText id="email" name="email" className={classNames({ 'p-invalid': isFormFieldValid('email') })} value={formik.values.email} onChange={formik.handleChange} onBlur={(e) => { formik.handleBlur(e); if (formik.values.email && !formik.errors.email) verificaEmail(formik.values.email); }} /> : <Skeleton height="35px" />}
                                {formik.errors.email && formik.touched.email && <ErrorValidationMessage message={formik.errors.email} />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4 p-md-4">
                                <label htmlFor="dataNascimento" className={classNames({ 'p-error': isFormFieldValid('dataNascimento') })}>Data de nascimento</label>
                                <BrCalendar id="dataNascimento" name="dataNascimento" value={formik.values.dataNascimento} onChange={formik.handleChange} placeholder={isEditing ? new Date(formik.values.dataNascimento).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : ""} className={classNames({ 'p-invalid': isFormFieldValid('dataNascimento') })} yearRange={`1922:${new Date().getFullYear()}`} />
                                {formik.errors.dataNascimento && formik.touched.dataNascimento && <ErrorValidationMessage message={formik.errors.dataNascimento} />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="responsavel" className={classNames({ 'p-error': isFormFieldValid('responsavel') })}>Nome do Responsável (Caso menor de idade)</label>
                                {!isLoading ? <InputText id="responsavel" name="responsavel" className={classNames({ 'p-invalid': isFormFieldValid('responsavel') })} value={formik.values.responsavel} onChange={formik.handleChange} /> : <Skeleton height="35px" />}
                                {formik.errors.responsavel && formik.touched.responsavel && <ErrorValidationMessage message={formik.errors.responsavel} />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="celular" className={classNames({ 'p-error': isFormFieldValid('celular') })}>Telefone Celular</label>
                                {!isLoading ? <InputMask id="celular" name="celular" unmask={true} value={formik.values.celular} mask={formik.values.celular !== undefined && formik.values.celular.length <= 10 ? "(99) 9999-9999?9" : "(99) 99999-9999"} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('celular') })} /> : <Skeleton height="35px" />}
                                {formik.errors.celular && formik.touched.celular && <ErrorValidationMessage message={formik.errors.celular} />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="telefone" className={classNames({ 'p-error': isFormFieldValid('telefone') })}>Telefone Fixo</label>
                                {!isLoading ? <InputMask id="telefone" name="telefone" mask={formik.values.telefone !== undefined && formik.values.telefone !== null && formik.values.telefone.length <= 10 ? "(99) 9999-9999?9" : "(99) 99999-9999"} unmask={true} value={formik.values.telefone} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('telefone') })} /> : <Skeleton height="35px" />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="tipo" className={classNames({ 'p-error': isFormFieldValid('tipo') })}>Tipo de Perfil</label>
                                {!isLoading ? <Dropdown id="tipo" name="tipo" value={formik.values.tipo} options={formik.values.tipoPerfis} emptyMessage="Nenhum tipo encontrado" filter={true} onChange={(e) => formik.setFieldValue("tipo", e.value)} className={classNames({ 'p-invalid': isFormFieldValid('tipo') })} placeholder="Selecione o tipo de perfil" showClear={true} /> : <Skeleton height="35px" />}
                                {formik.errors.tipo && formik.touched.tipo && <ErrorValidationMessage message={formik.errors.tipo} />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="deficiencia" className={classNames({ 'p-error': isFormFieldValid('deficiencia') })}>Possui alguma Deficiência?</label>
                                {!isLoading ? <Dropdown id="deficiencia" name="deficiencia" value={formik.values.deficiencia} options={OPCOES_DEFICIENCIA} onChange={(e) => formik.setFieldValue("deficiencia", e.value)} placeholder="Selecione uma opção" className={classNames({ 'p-invalid': isFormFieldValid('deficiencia') })} /> : <Skeleton height="35px" />}
                                {formik.errors.deficiencia && formik.touched.deficiencia && <ErrorValidationMessage message={formik.errors.deficiencia} />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="nomeSocial">Nome Social</label>
                                {!isLoading ? <InputText id="nomeSocial" name="nomeSocial" value={formik.values.nomeSocial} onChange={formik.handleChange} /> : <Skeleton height="35px" />}
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="arquivosDocs">Ver / Anexar Docs</label>
                                <Button label="Arquivos" type="button" onClick={async () => { await getDocs(); setShowDocs(true); }} icon="pi pi-folder-open" iconPos="right" disabled={!formik.values.cpf} />
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="obs" style={{ fontWeight: 'bold' }}>Observações</label>
                                <InputTextarea id="obs" name="obs" value={formik.values.obs ? formik.values.obs.replace(/<[^>]*>/g, '') : ''} onChange={formik.handleChange} onFocus={() => setShowObs(true)} rows={1} autoResize className={classNames('w-full', { 'p-invalid': isFormFieldValid('obs') })} style={{ minHeight: '38px', maxHeight: '110px', overflowY: 'auto', resize: 'none' }} disabled={!formik.values.cpf} placeholder="Clique para gerenciar observações..." />
                            </div>

                            <div className="p-field p-col-12">
                                <label htmlFor="lgpdAceite">
                                    <Checkbox id="lgpdAceite" name="lgpdAceite" checked={formik.values.lgpdAceite} onChange={() => formik.setFieldValue('lgpdAceite', !formik.values.lgpdAceite)} className={classNames({ 'p-invalid': isFormFieldValid('lgpdAceite') })} style={{ marginRight: '5px' }} />
                                    Estou ciente e de acordo com os termos... <span style={{ color: "#2196f3", cursor: 'pointer' }} onClick={() => setShowLGPD(true)}>(LGPD)</span>.
                                </label>
                                {formik.errors.lgpdAceite && formik.touched.lgpdAceite && <ErrorValidationMessage message={formik.errors.lgpdAceite} />}
                            </div>

                            <p><b>ATENÇÃO:</b> A senha padrão para instrutores e administradores é conservatorio123. É recomendado alterar a mesma no primeiro acesso.</p>
                        </div>

                        <div className="p-d-flex p-jc-end p-mr-1">
                            {!isLoading ? <Button label={isEditing ? 'Atualizar' : 'Salvar'} type="submit" icon="pi pi-check" iconPos="right" loading={isSubmiting} /> : <Skeleton width="82px" height="35px" />}
                        </div>
                    </form>
                </div>
                
                <div className="p-col-12">
                    {isEditing && <TabelaMatriculasPerfil matriculasPerfil={defaultValues.id} />}
                </div>
            </div>
        </>
    );
};